module.exports = __webpack_public_path__ + "img/mu.f30f99d8.svg";